import { Link } from 'react-router';
import { num } from '@/lib/format';
import { useT } from '@/lib/i18n';
import { useAuth } from '@/lib/auth';
import { Card, Kpi, Loading, PageHeader } from '@/components/ui';
import { ProblemsCell, StateBadge, useClients } from './clients';

/** the first screen: how many clients, in which state, and which of them need a look */
export function DashboardPage() {
  const t = useT();
  const me = useAuth((s) => s.session?.user);
  const list = useClients();
  const s = list.data?.summary;
  const needLook = (list.data?.items ?? []).filter((r) => r.problems.length > 0);
  return (
    <>
      <PageHeader title={`${t('Welcome')}, ${me?.displayName ?? ''}`} subtitle={t('Your three jobs: bring a client on, support them, push updates.')} />
      {list.isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <Kpi label={t('Clients')} value={num(s?.total)} />
            <Kpi label={t('Live')} value={num(s?.live)} tone="good" />
            <Kpi label={t('Testing')} value={num(s?.testing)} />
            <Kpi label={t('With problems')} value={num(s?.withProblems)} tone={s?.withProblems ? 'bad' : 'default'} />
          </div>
          <Card title={t('Clients that need a look')} actions={<Link to="/clients" className="text-xs font-medium text-brand-700 hover:underline">{t('All clients')}</Link>}>
            {needLook.length === 0 ? (
              <p className="text-sm text-ink-600">{t('Every client is fine.')}</p>
            ) : (
              <ul className="divide-y divide-ink-100">
                {needLook.map((r) => (
                  <li key={r.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
                    <Link to={`/clients/${r.id}`} className="flex items-center gap-2 text-sm font-medium text-ink-900 hover:underline">
                      {r.nameEn} <StateBadge state={r.state} />
                    </Link>
                    <ProblemsCell row={r} />
                  </li>
                ))}
              </ul>
            )}
          </Card>
        </>
      )}
    </>
  );
}
